import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, of } from "rxjs";
import { share, map } from "rxjs/operators";
import { JwtHelperService } from "@auth0/angular-jwt";
import { Constants } from "../constants/constants";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  constructor(private http: HttpClient) {}

  refreshToken(): Observable<string> {
    const url = Constants.BASE_URL + Constants.URL_REFRESH;
    //alert("respuesta"+url);
    // append refresh token if you have one
    const refreshToken = String(sessionStorage.getItem("refresh_token"));
    const expiredToken = String(sessionStorage.getItem("token"));
    let infoUsuario = JSON.parse(sessionStorage.getItem("infoUsuario"));
    //console.log(refreshToken);
    //alert(JSON.stringify(infoUsuario));
    return this.http
      .get(url, {
        headers: new HttpHeaders()
          .set("refreshtoken", refreshToken)
          .set("token", expiredToken)
          .set("idusuario", String(infoUsuario[0].IdUsuario)),
        observe: "response",
      })
      .pipe(
        share(), // <========== YOU HAVE TO SHARE THIS OBSERVABLE TO AVOID MULTIPLE REQUEST BEING SENT SIMULTANEOUSLY
        map((res) => {
          const token = res.headers.get("token");
          const newRefreshToken = res.headers.get("refresh_token");

          let body = JSON.stringify({ ...res.body });
          let bodyJSON = JSON.parse(body);
          //console.log(JSON.stringify(bodyJSON));
          // store the new tokens
          sessionStorage.setItem("refresh_token", bodyJSON.refresh_token);
          sessionStorage.removeItem("token");
          sessionStorage.setItem("token", bodyJSON.token);

          return bodyJSON.token;
        })
      );
  }

  getToken(): Observable<string> {
    //alert("aqui");
    const token = sessionStorage.getItem("token");
    const decoder = new JwtHelperService();
    const isTokenExpired = decoder.isTokenExpired(token);
    //console.log("expiro: "+isTokenExpired);
    if (!isTokenExpired) {
      return of(token);
    }

    return this.refreshToken();
  }

  // other auth methods
}
